
<div class="shifts-overview">
  <div>
    <form v-on:submit.prevent="submitSearch">
      <div class="d-flex justify-content-start">
        <div>
          <div class="label">Date</div>
          <board-item-date-picker v-model="searchDateRange" :customClass="'boardOverview'" :columns="2" :is-range="true" :mode="'date'" />
        </div>
      </div>
    </form>
  </div>

  <hr />

  <div class="shift-handovers-container">
    <div v-for="(shiftOverview, index) in shiftsOverview" :key="shiftOverview + index">
      <div class="shift-handovers">
        <div class="sh-header" @click="shiftOverview.isCollapsed = !shiftOverview.isCollapsed">
          <div class="shift-handover">
            <div class="ml-2 sh-toggle">
              <i
                class="fas"
                :class="{ 'fa-chevron-down': !shiftOverview.isCollapsed, 'fa-chevron-right': shiftOverview.isCollapsed }"
              ></i>
            </div>

            <div class="ml-1 sh-prop-m">
              {{ shiftOverview.handoverDateTime | formatDateWithoutHours }}
            </div>

            <div class="sh-prop-l ml-3">{{ shiftOverview.shift != null ? shiftOverview.shift.shiftType.name : 'Initial shift' }}</div>

            <div class="sh-prop-xl align-items-center">
              <i class="far fa-user mr-2"></i>
              {{ shiftOverview.shiftSupervisor }}
            </div>

            <div class="sh-prop-l d-flex justify-content-start">
              <div style="width: 25px">
                {{ shiftOverview.relevantItemsCount }}
              </div>
              <div class="ml-2 badge badge-pill badge-info sh-prop-s">Relevant</div>
            </div>

            <div class="sh-prop-l d-flex justify-content-start">
              <div style="width: 25px">
                {{ getItemsCount(shiftOverview.boardItemsSummary, itemsStatus.Planned).count }}
              </div>
              <div class="ml-2 badge badge-pill badge-primary sh-prop-s">
                {{ getItemsCount(shiftOverview.boardItemsSummary, itemsStatus.Planned).status }}
              </div>
            </div>

            <div class="sh-prop-l d-flex justify-content-start">
              <div style="width: 25px">
                {{ getItemsCount(shiftOverview.boardItemsSummary, itemsStatus.InProgress).count }}
              </div>
              <span class="ml-2 badge badge-pill badge-warning sh-prop-s">
                {{ getItemsCount(shiftOverview.boardItemsSummary, itemsStatus.InProgress).status }}
              </span>
            </div>

            <div class="sh-prop-l d-flex justify-content-start">
              <div style="width: 25px">
                {{ getItemsCount(shiftOverview.boardItemsSummary, itemsStatus.Done).count }}
              </div>
              <div class="pt-1 ml-2 badge badge-pill badge-success sh-prop-s">
                {{ getItemsCount(shiftOverview.boardItemsSummary, itemsStatus.Done).status }}
              </div>
            </div>

            <div class="sh-prop-l d-flex justify-content-start">
              <div style="width: 25px">
                {{ shiftOverview.sharedItemsCount }}
              </div>
              <div class="ml-2 badge badge-pill badge-secondary sh-prop-s">Shared</div>
            </div>
          </div>
        </div>

        <transition name="shift-details">
          <div v-if="!shiftOverview.isCollapsed">
            <div class="shift-handover-details">
              <hr class="mt-1 mb-2" />
              <ShiftOverview :shiftOverview="shiftOverview" class="ml-2 mt-2" />
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div v-if="!shiftsOverview || !shiftsOverview.length">
      <div class="label justify-content-center d-flex">No Shifts found</div>
    </div>

    <div v-if="loading" class="d-flex align-items-center justify-content-center p-5">
      <loading-spinner></loading-spinner>
    </div>
  </div>
</div>
